import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

// routes config
import routes from '../Routes/Routes'

const AppContent = () => {
    return (
        <div className="hold-transition sidebar-mini layout-fixed">
            <div className="wrapper">
                <Routes>
                    {routes.map((route, idx) => {
                        return (
                            route.element && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    exact={route.exact}
                                    name={route.name}
                                    element={<route.element />}
                                />
                            )
                        )
                    })}
                    <Route path="/" element={<Navigate to="dashboard" replace />} />
                </Routes>
            </div>
        </div>
    )
}

export default React.memo(AppContent)
